import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '..';
import { EditListingDevelopmentSituationsForm } from '../../forms';

import css from './EditListingDevelopmentSituationsPanel.module.css';
import { convertKeywordToSearch } from '../../util/search';
import config from '../../config';

const EditListingDevelopmentSituationsPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const {
    publicData : { developmentSituations, developmentSituationsOther }
  } = currentListing?.attributes || {};
  const { filters } = config.custom;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingDevelopmentSituationsPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingDevelopmentSituationsPanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingDevelopmentSituationsPanel.createListingTitle" />
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingDevelopmentSituationsForm
        className={css.form}
        initialValues={{ developmentSituations, developmentSituationsOther }}
        saveActionMsg={submitButtonText}
        onSubmit={values => {
          const { developmentSituations, developmentSituationsOther } = values;
          const updateValues = {
            publicData: {
              developmentSituations,
              developmentSituationsOther,
              developmentSituationsToSearch: convertKeywordToSearch({
                filterId: 'developmentSituations',
                filters,
                keyList: developmentSituations,
                keyOther: developmentSituationsOther
              })
            },
          };

          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingDevelopmentSituationsPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingDevelopmentSituationsPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingDevelopmentSituationsPanel;
